import type { UUID } from '@types';

export const B2B_API = {
  siteConfig: '/b2b-sites',
  sitePages: (siteId: UUID | undefined) => `/b2b-sites/${siteId}/pages`,
  sitePageDetails: (siteId: UUID | undefined, pageId: number | undefined) =>
    `/b2b-sites/${siteId}/pages/${pageId}`,
  siteWidgetDetails: (siteId: UUID | undefined, widgetId: number | undefined) =>
    `/b2b-sites/${siteId}/widgets/${widgetId}`,
  translations: (locale: string) => `/contents/${locale}`,
  clientDetails: (siteId: UUID | undefined) => `/b2b-sites/${siteId}/client`,
  streams: (siteId: UUID | undefined) => `/b2b-sites/${siteId}/streams`,
  streamEvents: (siteId: UUID | undefined, streamId: UUID | undefined) =>
    `/b2b-sites/${siteId}/streams/${streamId}/events`,
};

export const CONTENT_API = {
  // Add the rest as you migrate staticContent:
  personalPlaylist: (slugOrId: string | number, locale: string) =>
    `/playlists/${slugOrId}/pistes?lang=${locale}&ver=2`,
  playlist: (slugOrId: string | number, locale: string) =>
    `/radios/${slugOrId}?lang=${locale}&universeAsFilter=true`,
  album: (slugOrId: string | number, locale: string) =>
    `/album/${slugOrId}?lang=${locale}&universeAsFilter=true`,
  video: (slugOrId: string | number, locale: string) =>
    `/videos/${slugOrId}?lang=${locale}&universeAsFilter=true`,
  article: (slugOrId: string | number, locale: string) =>
    `/v2/news/${slugOrId}?lang=${locale}&universeAsFilter=true`,
  podcast: (podcastId: number, locale: string) =>
    `/podcast/${podcastId}?lang=${locale}&universeAsFilter=true`,
  podcastChapterStream: (slugOrId: string | number, locale: string) =>
    `/chapter/${slugOrId}/stream?lang=${locale}&universeAsFilter=true`,
  collection: (
    slugOrId: string | number,
    locale: string,
    universe = 'classical',
  ) => `/partner/${slugOrId}?lang=${locale}&universe=${universe}`,
  collectionContents: (
    collectionId: string | number,
    locale: string,
    universe = 'classical',
  ) => `/partner/${collectionId}/contents?lang=${locale}&universe=${universe}`,
  quiz: (slugOrId: string | number, locale: string) =>
    `/quizzes/${slugOrId}?lang=${locale}&universeAsFilter=true`,
  game: (slugOrId: string | number, locale: string) =>
    `/games/${slugOrId}?lang=${locale}&universeAsFilter=true`,
  gallery: (slugOrId: string | number, locale: string) =>
    `/galleries/${slugOrId}?lang=${locale}&universeAsFilter=true`,
} as const;

export const AUTH_API = {
  salutations: '/auth/salutations',
  countries: '/auth/countries',
};
